import React from 'react'

import { LntSelect } from '@app/components/base'

import type { ReactElement } from 'react'
import type { SelectRendererProps } from './types'

export const SelectRenderer = <RecordType = unknown,>(props: SelectRendererProps<RecordType>): ReactElement => {
  const { record, onChange, ...restProps } = props

  const handleChange = (value?: number): void => {
    onChange?.(value ?? null, record)
  }

  return (
    <LntSelect<number>
      { ...restProps }
      onChange={ handleChange }
    />
  )
}
